import React, { useEffect } from 'react'
import "../styles/login.css"
import N_Logo from "../assets/Indegene-N-logo.svg"
import NextLogo from "../assets/myorders-next-logo.svg"
import MicrosoftLogo from "../assets/MicrosoftLogo.svg"
import { Button } from 'antd'
import { getIsUserLoggedIn } from '../utilities/sessionHelper'

const Login=()=> {
  useEffect(() => {
    const isloggedin=getIsUserLoggedIn();
    if(isloggedin){
      window.location.pathname = '/';
    }
  });
  return (
    <div className='login-body'>
    <div className="login-container">
      <div className="login-section login-logo">
        {/* Your logo and tagline content goes here */}
        <img src={N_Logo} alt="Logo" />
        <h2 className='myOrders-tagline' style={{marginTop:'20px'}}>Unlocking Seamless Operations</h2>
      </div>
      <div className="login-section login-form">
        {/* Your login form goes here */}
        <form>
          <img src={NextLogo} alt="Logo" />
          <h2 style={{font: 'normal normal bold 24px/32px Nunito Sans'}}>Welcome to myOrders</h2>
          <p style={{
            font: 'normal normal normal 14px/20px Nunito Sans', 
            fontSize:'15px'
          }}>Sign in using your Office email id & password</p>
          <div style={{ padding: '10px' }}>
                        <a href={`${process.env.REACT_APP_SSO_URL}indegenessoconnect/oauth2/authorization/myOrders`} style={{textDecoration:'none'}}>
                          <Button 
                            style={{ background: '#FFFFFF 0% 0% no-repeat padding-box', 
                                    borderRadius: '3px', 
                                    padding: '5px', 
                                    paddingLeft: '10px', 
                                    height: 'auto', 
                                    width: '312px', 
                                    textAlign: "left", 
                                    justifyContent:'left',
                                    display: 'flex',
                                    alignItems: 'center',
                                    boxShadow: '3px 4px 10px 0px #F4F4F4' }}> 
                                    <img src={MicrosoftLogo} alt ="microsoft-logo" ></img>
                                    <span style={{ textAlign: 'left', 
                                    font: 'normal normal normal 12px/20px Nunito Sans', 
                                    letterSpacing: '0px', 
                                    color: '#231F20', 
                                    opacity: 1, 
                                    marginLeft: '10px',
                                    textDecoration: 'none'
                                     }}> Sign in with Microsoft</span>
                            </Button>
                        </a>
                      </div>
        </form>
      </div>
    </div>
    </div>
  )
}
export default Login;